import { DevicePermission } from '@office-start/metaos-hub-sdk';
import { format } from '@office-start/string-formatter-utility';
export const formatAppPermissionsDialogStrings = ({ appDefinitionPermissions, appName, stringResources, }) => {
    const permissionsStringRequired = appDefinitionPermissions.map((permission) => {
        switch (permission) {
            case 'geolocation':
                return {
                    description: stringResources.descriptionAppPermissionsDialog,
                    nameOfPermission: stringResources.geoLocation,
                    devicePermission: DevicePermission.GeoLocation,
                };
            case 'media':
                return {
                    description: stringResources.descriptionAppPermissionsDialog,
                    nameOfPermission: stringResources.media,
                    devicePermission: DevicePermission.Media,
                };
            /**
             * TODO: We don't anticipate app developers using notifications, midi, and external, since we're deprecating them.
             * Once we remove them from the manifest, we willl remove these cases.
             */
            case 'midi':
                return {
                    description: stringResources.descriptionAppPermissionsDialog,
                    nameOfPermission: stringResources.midi,
                    devicePermission: DevicePermission.Midi,
                };
            case 'notifications':
                return {
                    description: stringResources.descriptionAppPermissionsDialog,
                    nameOfPermission: stringResources.notifications,
                    devicePermission: DevicePermission.Notifications,
                };
            case 'openexternal':
                return {
                    description: stringResources.descriptionAppPermissionsDialog,
                    nameOfPermission: stringResources.openExternal,
                    devicePermission: DevicePermission.OpenExternal,
                };
            default:
                // TODO: log supplied app definition permissions string not supported
                return;
        }
    });
    const filteredPermissionsStringRequired = permissionsStringRequired.filter((permission) => permission !== undefined);
    return {
        caption: stringResources.captionAppPermissionsDialog,
        closeButtonAria: stringResources.closeButtonAriaAppPermissionsDialog,
        navigateToInstalledAppsControlText: 'Set other app permissions',
        subtitle: stringResources.subtitleAppPermissionsDialog,
        title: format(stringResources.titleAppPermissionsDialog, appName),
        saveButtonLabel: stringResources.saveButtonLabelAppPermissionsDialog,
        saveButtonAria: stringResources.saveButtonAriaAppPermissionsDialog,
        cancelButtonLabel: stringResources.cancelButtonLabelAppPermissionsDialog,
        cancelButtonAria: stringResources.cancelButtonAriaAppPermissionsDialog,
        // TODO: find a way to add this format to the loc string
        permissions: filteredPermissionsStringRequired,
    };
};
//# sourceMappingURL=formatAppPermissionsDialogStrings.js.map